export type PrometheusValkeySlaveLagStatsBackendApiProps = {
    created: number;
    connected_slave_lag: number;
};

export default class PrometheusValkeySlaveLagStats {
    readonly created: number;
    readonly connectedSlaveLag: number;

    constructor(props: PrometheusValkeySlaveLagStatsBackendApiProps) {
        this.created = props.created;
        this.connectedSlaveLag = props.connected_slave_lag;
    }
}
